import themeConfig from '../../themeConfig';
import AppConstants from "../appConstants";
import { CONTENT } from '../enums/enum-content';
import VueI18n from '../i18n/i18n';
import store from '../store/store';
import localStorageHelper from './local-storage-helper';

class MenuBuilderHelper {
  getFirstItemMenu() {
    if (!store) return { id: null };
    const subject = store.state.subjectsMenu[0];
    if (subject) return store.state.subjectsMenu[0];

    if (localStorageHelper.getUserHasLoggedIn()) {
      const { rights } = localStorageHelper.getCurrentUser();
      const menu = this.buildMenu(rights);
      return menu[0].items[0];
    }
    return null;
  }
  getInformativePageFirstItemMenu() {
    const subject = this.getFirstItemMenu();
    if (subject && subject.id) {
      return `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${this.getFirstItemMenu().id}`;
    }
    return `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/0`;
  }
  buildMenu(userRights) {
    const menu = [];

    const commodityMenu = userRights.map(item => {
      return {
        url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${item.id}`,
        name: item[`label${VueI18n.locale}`],
        slug: item.nome.toLowerCase(),
        icone: item.icone,
        isDisabled: !item.habilitado,
        id: item.id,
        originCode: item.originCode,
        mne: item.mne,
        platformWdmaRoute: item.platformWdmaRoute || []
      };
    });
    const enableMenuOptions = commodityMenu.filter(c => !c.isDisabled);
    const disableMenuOptions = commodityMenu.filter(c => c.isDisabled);

    // Add menu item - all commodities

    // enableMenuOptions.unshift({
    //   divider: true
    // });

    if (themeConfig.client == AppConstants.PLATFORM_CLIENT.CMA) {
      if (commodityMenu.length > 1) {
        enableMenuOptions.unshift({
          url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/0`,
          name: 'Todos Assuntos',
          slug: 'allsubjects',
          icone: 'AllIcon',
          isDisabled: false,
          i18n: 'MENU',
          i18nData: 'AllSubjects',
          id: 0,
          originCode: 0,
          mne: 'Todas Commodities',
          platformWdmaRoute: [
            { country: { code: 1 }, routeName: 'Todos' },
            { country: { code: 2 }, routeName: 'TodosEUA' },
            { country: { code: 3 }, routeName: 'TodosESP' },
            { country: { code: 4 }, routeName: 'TodosARG' },
            { country: { code: 5 }, routeName: 'TodosARG' },
            { country: { code: 6 }, routeName: 'TodosARG' },
            { country: { code: 7 }, routeName: 'TodosARG' },
            { country: { code: 8 }, routeName: 'TodosARG' },
            { country: { code: 9 }, routeName: 'TodosARG' },
            { country: { code: 10 }, routeName: 'TodosPOR' },
          ]
        });
      }
      menu.push({
        header: 'Assuntos',
        i18n: 'MENU',
        i18nData: 'Subjects',
        items: enableMenuOptions
      });
    }
    if (themeConfig.client == AppConstants.PLATFORM_CLIENT.SAFRAS) {
      if (commodityMenu.length > 1) {
        // All commodities
        enableMenuOptions.unshift({
          url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/0`,
          name: 'Todas',
          slug: 'allcommodities',
          icone: 'AllIcon',
          isDisabled: false,
          i18n: 'MENU',
          i18nData: 'AllCommodities',
          id: 0,
          originCode: 0,
          mne: 'Todas Commodities',
          platformWdmaRoute: [
            { country: { code: 1 }, routeName: 'Todos' },
            { country: { code: 2 }, routeName: 'TodosEUA' },
            { country: { code: 3 }, routeName: 'TodosESP' },
            { country: { code: 4 }, routeName: 'TodosARG' },
            { country: { code: 5 }, routeName: 'TodosARG' },
            { country: { code: 6 }, routeName: 'TodosARG' },
            { country: { code: 7 }, routeName: 'TodosARG' },
            { country: { code: 8 }, routeName: 'TodosARG' },
            { country: { code: 9 }, routeName: 'TodosARG' },
            { country: { code: 10 }, routeName: 'TodosPOR' },
          ]
        });
      }

      menu.push({
        header: 'Commodities',
        i18n: 'MENU',
        i18nData: 'Commodities',
        items: enableMenuOptions
      });
    }

    // Home Menu
    // enableMenuOptions.unshift({
    //   url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/500`,
    //   name: 'Home',
    //   slug: 'home',
    //   icone: 'HomeIcon',
    //   isDisabled: false,
    //   i18n: 'MENU',
    //   i18nData: 'Home',
    //   id: 500,
    //   originCode: 250,
    // });

    if (disableMenuOptions.length > 0) {
      menu.push({
        header: 'Assine já',
        i18n: 'MENU',
        i18nData: 'DisabledItems',
        items: disableMenuOptions
      });
    }



    return menu;
  }

  buildCacheMenu(subjects) {
    const menu = [];

    const commodityMenu = subjects.map(item => {
      return {
        url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${item.code}`,
        name: item[`label${VueI18n.locale}`],
        slug: item[`label${VueI18n.locale}`].toLowerCase(),
        icone: item.icon,
        isDisabled: !item.active,
        id: item.code,
        originCode: 0,
        mne: item.mne
      };
    });
    const enableMenuOptions = commodityMenu.filter(c => !c.isDisabled);
    const disableMenuOptions = commodityMenu.filter(c => c.isDisabled);

    if (themeConfig.client == AppConstants.PLATFORM_CLIENT.SAFRAS) {

      // All commodities
      enableMenuOptions.unshift({
        url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/0`,
        name: 'Todas',
        slug: 'allcommodities',
        icone: 'AllIcon',
        isDisabled: false,
        i18n: 'MENU',
        i18nData: 'AllCommodities',
        id: 0,
        originCode: 0,
        mne: 'Todas Commodities'
      });

      menu.push({
        header: 'Commodities',
        i18n: 'MENU',
        i18nData: 'Commodities',
        items: enableMenuOptions
      });
    }
    if (disableMenuOptions.length > 0) {
      menu.push({
        header: 'Assine já',
        i18n: 'MENU',
        i18nData: 'DisabledItems',
        items: disableMenuOptions
      });
    }

    return menu;
  }

  buildHomeMenu() {
    const menu = [];
    // menu.push({
    //   url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/500`,
    //   name: 'Home',
    //   slug: 'home',
    //   icone: 'HomeIcon',
    //   isDisabled: false,
    //   i18n: 'MENU',
    //   i18nData: 'Home',
    //   id: 500,
    //   originCode: 250,
    // });

    const enableMenuOptions = [
      { name: 'Todas Commodities', slug: 'allcommodities', icone: 'AllIcon', isDisabled: false, i18n: 'MENU', i18nData: 'AllCommodities', id: 0, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/0` },
      { name: 'Açúcar & Etanol', slug: 'sugar', icone: 'AcucarIcon', isDisabled: false, id: 1, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${1}` },
      { name: 'Algodão', slug: 'cotton', icone: 'AlgodaoIcon', isDisabled: false, id: 3, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${3}` },
      { name: 'Arroz', slug: 'rice', icone: 'ArrozIcon', isDisabled: false, id: 4, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${4}` },
      { name: 'Boi', slug: 'ox', icone: 'BoiIcon', isDisabled: false, id: 6, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${6}` },
      { name: 'Café', slug: 'coffe', icone: 'CafeIcon', isDisabled: false, id: 7, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${7}` },
      { name: 'Feijão', slug: 'bean', icone: 'FeijaoIcon', isDisabled: false, id: 11, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${11}` },
      { name: 'Frango', slug: 'chicken', icone: 'FrangoIcon', isDisabled: false, id: 12, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${12}` },
      { name: 'Milho', slug: 'corn', icone: 'MilhoIcon', isDisabled: false, id: 13, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${13}` },
      { name: 'Soja', slug: 'soy', icone: 'SojaIcon', isDisabled: false, id: 16, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${16}` },
      { name: 'Farelo & Óleo Soja', slug: 'bran', icone: 'FareloIcon', isDisabled: false, id: 17, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${17}` },
      { name: 'Suíno', slug: 'swine', icone: 'SuinoIcon', isDisabled: false, id: 20, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${20}` },
      { name: 'Trigo', slug: 'wheat', icone: 'TrigoIcon', isDisabled: false, id: 21, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${21}` },
      { name: 'Agricultura de Precisão', slug: 'agricultureprecision', icone: 'AgriculturaPrecisaoIcon', isDisabled: false, id: 202, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${202}` },
      { name: 'Bioenergia', slug: 'bioenergy', icone: 'BioenergiaIcon', isDisabled: false, id: 5, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${5}` },
      { name: 'Chicago', slug: 'chicago', icone: 'ChicagoIcon', isDisabled: false, id: 23, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${23}` },
      { name: 'Fertilizantes', slug: 'fertilizers', icone: 'FertilizerIcon', isDisabled: false, id: 201, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${201}` },
    ]

    const disableMenuOptions = [
      { name: 'Soluções de Hedge', slug: 'hedge', icone: 'HedgeIcon', isDisabled: true, id: 61, originCode: 250, url: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${61}` },
    ]

    menu.push({
      header: 'Commodities',
      i18n: 'MENU',
      i18nData: 'Commodities',
      items: enableMenuOptions
    });
    menu.push({
      header: 'Assine já',
      i18n: 'MENU',
      i18nData: 'DisabledItems',
      items: disableMenuOptions
    });
    // menu.push({
    //   url: `${AppConstants.NAVIGATION_PAGE_HOME}`,
    //   name: 'Início',
    //   slug: 'home',
    //   icone: 'AllIcon',
    //   isDisabled: false,
    //   i18n: 'MENU',
    //   i18nData: 'AllCommodities',
    //   id: 0,
    //   originCode: 0,
    // });

    // menu.push({
    //   header: 'Commodities',
    //   i18n: 'MENU',
    //   i18nData: 'Commodities', 
    //   items: enableMenuOptions
    // });

    return menu;
  }

  buildSubMenuAnalysis() {
    const data = [];
    data.push({ isLabel: true, text: VueI18n.t('REPORT_FILTER').Informative, habilitado: true });
    data.push(AppConstants.INFORMATIVE_FILTER_ALL_OPTION);


    data.push({ id: CONTENT.NEWS, nome: "Noticias", nomePtBr: "Noticias", nomeEnEu: "Noticias", nomeEsEs: "Noticias", nomeEsAr: "Noticias", habilitado: true, icone: "NewsIcon" });
    data.push({ id: CONTENT.CONSULTING_SAFRAS_TV, nome: "SAFRAS TV", nomePtBr: "SAFRAS TV", nomeEnEu: "SAFRAS TV", nomeEsEs: "SAFRAS TV", nomeEsAr: "SAFRAS TV", habilitado: true, icone: "SafrasTvIcon" });
    data.push({ id: CONTENT.CONSULTING_SAFRAS_PODCAST, nome: "SAFRAS Podcast", nomePtBr: "SAFRAS Podcast", nomeEnEu: "SAFRAS Podcast", nomeEsEs: "SAFRAS Podcast", nomeEsAr: "SAFRAS Podcast", habilitado: true, icone: "SafrasPodcastIcon" });
    data.push({ id: CONTENT.CONSULTING_COURSES, nome: "Cursos", nomePtBr: "Cursos", nomeEnEu: "Cursos", nomeEsEs: "Cursos", nomeEsAr: "Cursos", habilitado: true, icone: "CursosIcon" });
    data.push({ id: CONTENT.CONSULTING_SPEECHES, nome: "Palestras", nomePtBr: "Palestras", nomeEnEu: "Palestras", nomeEsEs: "Palestras", nomeEsAr: "Palestras", habilitado: true, icone: "PalestrasIcon" });
    data.push({ id: CONTENT.WEATHER, nome: "Clima", nomePtBr: "Clima", nomeEnEu: "Clima", nomeEsEs: "Clima", nomeEsAr: "Clima", habilitado: true, icone: "ClimaIcon" });

    // data.push({ isLabel: true, text: 'Cadastre-se', habilitado: true });

    data.push({ id: CONTENT.INFORMATIVE, nome: "Análises", nomePtBr: "Análises", nomeEnEu: "Análises", nomeEsEs: "Análises", nomeEsAr: "Análises", habilitado: false, icone: "ClipboardIcon" });
    data.push({ id: CONTENT.STATISTIC, nome: "Estatística", nomePtBr: "Estatística", nomeEnEu: "Estatística", nomeEsEs: "Estatística", nomeEsAr: "Estatística", habilitado: false, icone: "ActivityIcon" });
    data.push({ id: CONTENT.EXPORTS, nome: "Exportações & Importações", nomePtBr: "Exportações & Importações", nomeEnEu: "Exportações & Importações", nomeEsEs: "Exportações & Importações", nomeEsAr: "Exportações & Importações", habilitado: false, icone: "BoxIcon" });
    data.push({ id: CONTENT.CONSULTING, nome: "Consultoria", nomePtBr: "Consultoria", nomeEnEu: "Consultoria", nomeEsEs: "Consultoria", nomeEsAr: "Consultoria", habilitado: false, icone: "ConsultoriaIcon" });

    data.push({ id: CONTENT.ASK_ANALYST, nome: "Pergunte ao Analista", nomePtBr: "Pergunte ao Analista", nomeEnEu: "Pergunte ao Analista", nomeEsEs: "Pergunte ao Analista", nomeEsAr: "Pergunte ao Analista", habilitado: false, icone: "MessageCircleIcon" });
    data.push({ id: CONTENT.CONSULTING_EXCHANGE, nome: "Câmbio", nomePtBr: "Câmbio", nomeEnEu: "Câmbio", nomeEsEs: "Câmbio", nomeEsAr: "Câmbio", habilitado: false, icone: "CambioIcon" });
    data.push({ id: CONTENT.HEDGE_WHATS, nome: "Entenda o que é Hedge", nomePtBr: "Entenda o que é Hedge", nomeEnEu: "Entenda o que é Hedge", nomeEsEs: "Entenda o que é Hedge", nomeEsAr: "Entenda o que é Hedge", habilitado: false, icone: "WhatsHedgeIcon" });
    data.push({ id: CONTENT.HEDGE_COMMODITIES, nome: "Hedge de Commodities", nomePtBr: "Hedge de Commodities", nomeEnEu: "Hedge de Commodities", nomeEsEs: "Hedge de Commodities", nomeEsAr: "Hedge de Commodities", habilitado: false, icone: "HedgeCommoditiesIcon" });
    data.push({ id: CONTENT.HEDGE_WHATS, nome: "Hedge Cambial", nomePtBr: "Hedge Cambial", nomeEnEu: "Hedge Cambial", nomeEsEs: "Hedge Cambial", nomeEsAr: "Hedge Cambial", habilitado: false, icone: "HedgeCambialIcon" });
    return data;
  }
  buildSubMenuQuotes() {
    const data = [];
    data.push({ isLabel: true, text: VueI18n.t('REPORT_FILTER').Follow_Market, habilitado: true });
    data.push({ id: CONTENT.ACTIVE_MARKET, nome: "Meus Ativos", nomePtBr: "Meus Ativos", nomeEnEu: "Meus Ativos", nomeEsEs: "Meus Ativos", nomeEsAr: "Meus Ativos", habilitado: false, icone: "MeusAtivosIcon" });
    data.push({ id: CONTENT.PHYSICAL_MARKET, nome: "Mercado Físico", nomePtBr: "Mercado Físico", nomeEnEu: "Mercado Físico", nomeEsEs: "Mercado Físico", nomeEsAr: "Mercado Físico", habilitado: false, icone: "FisicoIcon" });
    data.push({ id: CONTENT.FUTURE_MARKET, nome: "Mercado Futuro", nomePtBr: "Mercado Futuro", nomeEnEu: "Mercado Futuro", nomeEsEs: "Mercado Futuro", nomeEsAr: "Mercado Futuro", habilitado: false, icone: "FutureMarketIcon" });
    data.push({ id: CONTENT.INDICATIVE_MARKET, nome: "Indicadores", nomePtBr: "Clima", nomeEnEu: "Clima", nomeEsEs: "Clima", nomeEsAr: "Clima", habilitado: false, icone: "IndicadoresIcon" });
    data.push({ id: CONTENT.EXCHANGE_MARKET, nome: "Câmbio, Forex & NDF", nomePtBr: "Câmbio, Forex & NDF", nomeEnEu: "Câmbio, Forex & NDF", nomeEsEs: "Câmbio, Forex & NDF", nomeEsAr: "Câmbio, Forex & NDF", habilitado: false, icone: "CambioIcon" });
    return data;
  }

}

export default new MenuBuilderHelper();
